import { apiClient } from './apiClient';

export async function getMapData() {
  // Returns shape compatible with IExpansionMapData
  return apiClient.get<Record<string, { name: string; entities: any[] }>>(`/map/entities`);
}

export async function createMapEntity(payload: { city: string; type: string; status: string; name: string; coords?: { topPct: number; leftPct: number }; latlng?: { lat: number; lng: number }; metrics?: any; media?: any; relatedIds?: string[] }) {
  return apiClient.post(`/map/entities`, payload);
}

export async function deleteMapEntity(id: string) {
  return apiClient.delete(`/map/entities/${id}`);
}

export async function updateMapEntity(id: string, patch: Partial<{ city: string; type: string; status: string; name: string; coords?: { topPct: number; leftPct: number }; latlng?: { lat: number; lng: number }; metrics?: any; media?: any; relatedIds?: string[] }>) {
  return apiClient.patch(`/map/entities/${id}`, patch);
}
